/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable no-unexpected-multiline */
import React, { useState, useEffect } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { AxiosResponse } from 'axios'
import {
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Button,
  Image,
  PageFooter
} from 'components'
import { Card, CollapseColumn, Row, Span, Col } from 'components'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useModal, useReportPrint } from 'hooks'
import useLoading from 'hooks/useLoading'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { IErrorContextMessage } from 'services/core/errorContextMessage'
import {
  GrupoIten,
  IRelatorioTtl,
  ReportsEffectivesNGTServices,
  TotalGeral
} from 'services/NGT/ReportsEffectives'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import { IRequestBody } from '../../ReportsEffectives'
import { TableContract } from './components'
import FormatarNumeros from 'utils/formatNumbers'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Box, LinearProgress } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

interface location {
  request_body: any
  name: any
  hash: string
  pathname: string
  search: string
  state: {
    name: string
    request_body: IRequestBody
  }
}

export interface GroupCardRelatorio {
  grupos: GroupCardRelatorioList[]
  totalGeral: TotalGeral
}

export interface GroupCardRelatorioList {
  isOpen: boolean
  chaveGrupo: string
  grupoItens: GrupoIten[]
}

const DEFAULT_RELATORIO_GROUPING_TTL: GroupCardRelatorio = {
  grupos: [],
  totalGeral: {
    cdContrato: '',
    competencia: '',
    dataCompFim: '',
    dataCompInicio: '',
    diretoria: '',
    diretoriaExecutiva: '',
    nmFornecedor: '',
    flStatusMobilizacao: '',
    grupo: '',
    qtAcesso: 0,
    qtAfastado: 0,
    qtAtivo: 0,
    qtCompartilhado: 0,
    qtDemitido: 0,
    qtTotalEfetivoComDemitido: 0,
    qtTotalEfetivoSemDemitido: 0,
    qtTransferido: 0,
    gerencia: '',
    gerenciaGeral: ''
  }
}

const DEFAULT_SCROLL_LOAD_ITEMS = 20

const DEFAULT_ERROR = 'Erro ao obter relatório.'

const ThirdpartyStaffBySupplier: React.FC = () => {
  const { setLoading } = useLoading()
  const { handlePrintEfetivosTerceirosPorContrato } = useReportPrint()
  const history = useHistory()
  const location = useLocation<location>()

  const { showModal } = useModal()

  const [errorContext, setErrorContext] = useState<IErrorContextMessage>({
    isError: false,
    message: DEFAULT_ERROR
  })
  const [excelProp, setExcelProp] = useState<any>()
  const [dataCompetenciaIni, setDataCompetenciaIni] = useState<string>('')
  const [dataCompetenciaFim, setDataCompetenciaFim] = useState<string>('')
  const [tableDataResponse, setTableDataResponse] =
    useState<GroupCardRelatorio>(DEFAULT_RELATORIO_GROUPING_TTL)
  const [slicedList, setSlicedList] = useState<GroupCardRelatorioList[]>([])

  const mesInicial = moment(
    location.state.request_body.competenciaDataIni
  ).isValid()
    ? moment(location.state.request_body.competenciaDataIni).format('MM/YYYY')
    : '---'
  const mesFinal = moment(
    location.state.request_body.competenciaDataFim
  ).isValid()
    ? moment(location.state.request_body.competenciaDataFim).format('MM/YYYY')
    : '---'

  const handleView = () => {
    setLoading('loading')

    ReportsEffectivesNGTServices()
      [location?.state?.name](location?.state?.request_body)
      .then(
        (response: AxiosResponse<IGenericEntityResponse<IRelatorioTtl>>) => {
          if (!response.data?.sucesso) {
            setLoading('idle')
            setErrorContext({
              isError: true,
              message: response?.data?.mensagem
            })
            return
          }

          const cardGrouping: GroupCardRelatorio = {
            grupos: response.data.entity.grupos.map((grupo) => ({
              ...grupo,
              isOpen: false
            })),
            totalGeral: response.data.entity.totalGeral
          }

          setDataCompetenciaIni(
            response.data.entity.grupos[0].grupoItens[0].dataCompInicio
          )

          setDataCompetenciaFim(
            response.data.entity.grupos[0].grupoItens[0].dataCompFim
          )

          setTableDataResponse(cardGrouping)
          setSlicedList(cardGrouping.grupos.slice(0, DEFAULT_SCROLL_LOAD_ITEMS))

          setExcelProp(response.data)
          setLoading('idle')
        }
      )
      .catch((error) => {
        setLoading('idle')
        // setErrorContext({
        //   isError: true,
        //   message: error.response.data.mensagem
        // })
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem || error.message || 'Falha ao obter relatório.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleExcel = () => {
    setLoading('loading')
    ReportsEffectivesNGTServices()
      .RelatorioExcel(excelProp, location.state.name)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download =
          'RELATORIO-EFETIVOS-DE-TERCEIROS-POR-CONTRATO.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  const compareCompetencias = (
    firstValue?: string,
    secondValue?: string
  ): number => {
    const sorting = firstValue
      ?.substring(3, 7)
      ?.localeCompare(secondValue?.substring(3, 7))

    if (sorting !== 0) {
      return sorting
    }

    return firstValue
      ?.substring(0, 2)
      ?.localeCompare(secondValue?.substring(0, 2))
  }

  const HeaderSupplierTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
      </Row>
      <Span
        text="EFETIVOS DE TERCEIROS POR CONTRATO"
        color={COLORS.blueFonts}
        fontSize="24px"
        fontWeight={FONTS.bold}
        textTransform="uppercase"
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      />
    </Card>
  )

  const nextPagination = (grupos: GroupCardRelatorioList[]) => {
    setTimeout(() => {
      const currentLength = slicedList.length
      const newItems = grupos.slice(
        currentLength,
        currentLength + DEFAULT_SCROLL_LOAD_ITEMS
      )
      setSlicedList((prevState) => prevState.concat([...newItems]))
    }, 1000)
  }

  useEffect(() => {
    handleView()
  }, [])

  const handleCollpasePdf = (index) => {
    const cpy = JSON.parse(
      JSON.stringify(tableDataResponse)
    ) as GroupCardRelatorio

    cpy.grupos[index].isOpen = !cpy.grupos[index].isOpen
    setTableDataResponse(cpy)
    setSlicedList((prev) => tableDataResponse.grupos.slice(0, prev.length))
  }

  const handleGeneratePdf = async () => {
    try {
      await handlePrintEfetivosTerceirosPorContrato({
        filename: `relatório-de-efetivos-por-contrato-${moment().format(
          'DD-MM-YYYY'
        )}`,
        data: {
          title: 'RELATÓRIO DE EFETIVOS POR CONTRATO',
          mesInicial: mesInicial || dataCompetenciaIni || '---',
          mesFinal: mesFinal || dataCompetenciaFim || '---',
          content: tableDataResponse?.grupos.map((contract) => ({
            cdContrato: contract?.grupoItens[0]?.cdContrato,
            nmFornecedor: contract?.grupoItens[0]?.nmFornecedor,
            de: contract?.grupoItens[0]?.diretoriaExecutiva || '---',
            dir: contract?.grupoItens[0]?.diretoria || '---',
            gg: contract?.grupoItens[0]?.gerenciaGeral || '---',
            ger: contract?.grupoItens[0]?.gerencia || '---',
            body: contract?.grupoItens
              .map((column) => [
                column?.competencia,
                column?.flStatusMobilizacao,
                column?.progressoMovimentacao,
                formatarNumero(column?.qtAtivo),
                formatarNumero(column?.qtDemitido),
                formatarNumero(column?.qtAcesso),
                formatarNumero(column?.qtTransferido),
                formatarNumero(column?.qtAfastado),
                formatarNumero(column?.qtCompartilhado),
                formatarNumero(column?.qtTotalEfetivoComDemitido),
                formatarNumero(column?.qtTotalEfetivoSemDemitido)
              ])
              .slice(0, -1),
            footer: (() => {
              const subTotal = contract.grupoItens.find(
                (contract) => contract.grupo === 'SubTotal'
              )

              return [
                formatarNumero(subTotal?.qtAtivo),
                formatarNumero(subTotal?.qtDemitido),
                formatarNumero(subTotal?.qtAcesso),
                formatarNumero(subTotal?.qtTransferido),
                formatarNumero(subTotal?.qtAfastado),
                formatarNumero(subTotal?.qtCompartilhado),
                formatarNumero(subTotal.qtTotalEfetivoComDemitido),
                formatarNumero(subTotal.qtTotalEfetivoSemDemitido)
              ]
            })()
          })),
          totalGeral: [
            formatarNumero(tableDataResponse?.totalGeral?.qtAtivo),
            formatarNumero(tableDataResponse?.totalGeral?.qtDemitido),
            formatarNumero(tableDataResponse?.totalGeral?.qtAcesso),
            formatarNumero(tableDataResponse?.totalGeral?.qtTransferido),
            formatarNumero(tableDataResponse?.totalGeral?.qtAfastado),
            formatarNumero(tableDataResponse?.totalGeral?.qtCompartilhado),
            formatarNumero(
              tableDataResponse?.totalGeral?.qtTotalEfetivoComDemitido
            ),
            formatarNumero(
              tableDataResponse?.totalGeral?.qtTotalEfetivoSemDemitido
            )
          ]
        }
      })
    } catch (error) {
      console.error('Erro ao gerar PDF:', error)
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao gerar PDF. Tente novamente.',
        txtButtonConfirm: 'OK',
        type: 'error'
      })
    } finally {
      //setLoading('idle')
    }
  }

  return (
    <>
      <Card
        marginTop={SPACING.spacing5}
        marginLeft={SPACING.spacing5}
        marginRight={SPACING.spacing5}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        id="divToPrint"
      >
        <HeaderSupplierTitle />
        <Card backgroundColor={COLORS.primary} padding="8px 0">
          <Row alignItems="center" justifyContent="center">
            <Span
              text={`Mes Inicial: ${
                dataCompetenciaIni ? dataCompetenciaIni : '---'
              }`}
              marginRight={SPACING.spacing50}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={`Mes Final: ${mesFinal}`}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
          </Row>
        </Card>
        <Row
          justifyContent="flex-end"
          marginTop="4.5px"
          alignItems="center"
          gap={'0.3rem'}
        >
          <>
            <a>
              <ExcelIcon onClick={handleExcel} style={{ marginTop: '1rem' }} />
            </a>
            <PdfIcon onClick={handleGeneratePdf} />
            <Button
              text="Voltar"
              startIcon={<ArrowBack />}
              marginLeft={SPACING.spacing15}
              marginRight="1rem"
              //variantButton="outlined"
              backgroundColor={COLORS.white} // Fundo branco
              textColor={COLORS.blueFonts} // Texto azul escuro
              borderColor={COLORS.blueFonts} // Borda azul claro
              boxShadow={`0 2px 4px ${COLORS.gray}`}
              height="3rem" // Sombra cinza
              style={{ textAlign: 'center' }}
              onClick={() =>
                history.push({
                  pathname: '/ngt/relatorios-efetivos'
                })
              }
            />
          </>
        </Row>
        <InfiniteScroll
          dataLength={slicedList.length}
          next={() => nextPagination(tableDataResponse.grupos)}
          hasMore={tableDataResponse.grupos.length > slicedList.length}
          loader={
            <Box sx={{ width: '100%', marginBottom: '20px' }}>
              <LinearProgress />
            </Box>
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Final da listagem</b>
            </p>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
          }
        >
          {slicedList?.map((contract, index) => {
            return (
              <CollapseColumn
                index={index}
                key={index.toString()}
                nuContrato={contract?.grupoItens[0]?.cdContrato}
                nmFornecedor={contract?.grupoItens[0]?.nmFornecedor}
                nmDiretoriaExecutiva={
                  contract?.grupoItens[0]?.diretoriaExecutiva
                }
                nmDiretoria={contract?.grupoItens[0]?.diretoria}
                nmGerenciaGeral={contract?.grupoItens[0]?.gerenciaGeral}
                nmGerencia={contract?.grupoItens[0]?.gerencia}
                isOpen={true}
                toggleExpand={handleCollpasePdf}
              >
                <Row alignItems="center" justifyContent="center">
                  <Span
                    text="MÃO DE OBRA"
                    textAlign="center"
                    color={COLORS.blueFonts}
                    fontSize="24px"
                    fontWeight="700"
                  />
                </Row>
                <TableContract
                  tableData={contract.grupoItens.sort((first, second) =>
                    compareCompetencias(first.competencia, second.competencia)
                  )}
                />
              </CollapseColumn>
            )
          })}
        </InfiniteScroll>
        <Box margin="0 1rem 0 1rem">
          <PageFooter>
            <TableContainerStyled style={{ marginTop: 0 }}>
              <TableStyled>
                <TableHeadStyled>
                  <TableRowStyled>
                    <TableCellStyled>Mês/Ano</TableCellStyled>
                    <TableCellStyled align="left"></TableCellStyled>
                    <TableCellStyled align="left">Ativo</TableCellStyled>
                    <TableCellStyled align="left">Demitido</TableCellStyled>
                    <TableCellStyled align="left">Acesso</TableCellStyled>
                    <TableCellStyled align="left">Transferido</TableCellStyled>
                    <TableCellStyled align="left">Afastado</TableCellStyled>
                    <TableCellStyled align="left">
                      Compartilhado
                    </TableCellStyled>
                    <TableCellStyled align="left">Total</TableCellStyled>
                    <TableCellStyled align="left">
                      Sem Demitidos
                    </TableCellStyled>
                  </TableRowStyled>
                </TableHeadStyled>

                <TableRowStyled style={{ background: COLORS.lightGray }}>
                  <TableCellStyled style={{ fontWeight: 'bold' }}>
                    Total Geral
                  </TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        1.5,
                        tableDataResponse?.totalGeral?.qtAtivo
                      )}%`
                    }}
                  >
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAtivo)}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        2,
                        tableDataResponse?.totalGeral?.qtDemitido
                      )}%`
                    }}
                  >
                    {formatarNumero(tableDataResponse?.totalGeral?.qtDemitido)}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        2,
                        tableDataResponse?.totalGeral?.qtAcesso
                      )}%`
                    }}
                  >
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAcesso)}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        2.4,
                        tableDataResponse?.totalGeral?.qtTransferido
                      )}%`
                    }}
                  >
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtTransferido
                    )}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        2,
                        tableDataResponse?.totalGeral?.qtAfastado
                      )}%`
                    }}
                  >
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAfastado)}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        3.5,
                        tableDataResponse?.totalGeral?.qtCompartilhado
                      )}%`
                    }}
                  >
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtCompartilhado
                    )}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        1.5,
                        tableDataResponse?.totalGeral?.qtTotalEfetivoComDemitido
                      )}%`
                    }}
                  >
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtTotalEfetivoComDemitido
                    )}
                  </TableCellStyled>
                  <TableCellStyled
                    style={{
                      paddingLeft: `${calcPadding(
                        3.5,
                        tableDataResponse?.totalGeral?.qtTotalEfetivoSemDemitido
                      )}%`
                    }}
                  >
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtTotalEfetivoSemDemitido
                    )}
                  </TableCellStyled>
                </TableRowStyled>
              </TableStyled>
            </TableContainerStyled>
            <Row justifyContent="flex-end" marginTop="1.5rem">
              <Button
                text="Voltar"
                variantButton="outlined"
                onClick={() =>
                  history.push({
                    pathname: '/ngt/relatorios-efetivos'
                  })
                }
              />
            </Row>
          </PageFooter>
        </Box>
      </Card>
      <SuccessModal
        message={errorContext.message}
        open={errorContext.isError}
        type={errorContext.message == DEFAULT_ERROR ? 'error' : 'alert'}
        handleConfirm={() => {
          setErrorContext({
            isError: false,
            message: ''
          })
          history.push({
            pathname: '/ngt/relatorios-efetivos'
          })
        }}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero) as unknown as number
}

function calcPadding(actualPadding, itemsAmount) {
  let padding = actualPadding
  if (itemsAmount >= 10) padding = actualPadding - 0.2
  if (itemsAmount >= 100) padding = actualPadding - 0.4
  if (itemsAmount >= 1000) padding = actualPadding - 0.7
  if (itemsAmount >= 10000) padding = actualPadding - 1.5

  if (padding < 0) return 0

  return padding
}

export default ThirdpartyStaffBySupplier
